export const USER_KEY = 'USER_KEY';
export const Facebook = 'http://www.facebook.com';
export const Twitter = 'http://www.twitter.com';
export const Linkedin = 'http://www.linkedin.com';
export const Pinterest = 'http://www.pinterest.com';
export const Google = 'http://www.google.com';
//export const baseURL='https://enerland-loopback.pre.geoactio.com/';
//export const baseURL='http://api.marketstack.com/v1/eod';
//export const baseURL='http://localhost:3001/';
export const baseURL = 'http://ayax:3000/';
//export const apiUrl="https://enerlandapi.pre.geoactio.com";
export const apiUrl="https://enerlandapi-enerlandgroup.msappproxy.net";
//export const apiUrl="http://localhost:3010";
export const apiGetPlantas = '/plantas';
export const apiUsuario = '/usuarios';
export const apiUsuarioActualizarPlantas = '/usuarios/plantas';
export const apiUsuarioMe = '/usuarios/me';
export const apiPing = '/ping';
export const apiPlantaUsuario = '/planta-usuarios';
export const apiCo2 = '/ahorroco2';
export const apiGetStreamin = '/cctvs/stream';
export const apiGetStreaminFile = '/cctvs/streaming/file';
export const apiRelojStreamin = '/cctvs/stream/timeutciso';
export const PageTitle = 'Enerland Group - Plantas';
export const tenant = '943fa85b-068d-404a-bacb-5f0baf8d31a8';
export const redirectUri="https://enerlandapp.enerlandgroup.com/";

//export const redirectUri='https://enerlandapp.azurewebsites.net';
export const clientId= 'd36e44a9-4802-4ec1-8411-408746c84ea2';
//export const redirectUri='https://localhost:3000';
//export const clientId= '1ea75abe-b119-405a-bf38-31feb5b35f58';
export const localStoregeTitle = 'localStoregeEnerland';
export const localStorageBoard = 'EnerlandPanel';
export const valor = 'Valor';
export const usuario = 'Usuario';
export const propiedad = 'Propiedad';
export const nombre = 'Nombre';
export const nombrePila = 'Nombre de pila';
export const apellidos = 'Apellidos';
export const roles = 'Roles';
export const esEscritor = 'es Escritor?';
export const esContribuidor = 'es Contribuidor?';
export const urlVideo = 'https://media.w3.org/2010/05/sintel/trailer_hd.mp4';

export const rutaIndex = '/';
export const rutaPlantas = '/plant';
export const rutaMapa = '/map';
export const rutaConfig = '/config';
export const rutaAddUser = '/adduser';
export const rutaPrecioMercado = '/precio-mercados';

export const rolAcceso = 'administrador';

export const widges = [
  { id: 'valueMapa', nombre: 'Mapa', value: 'On', widge: 'mapa', valor: true },
  {
    id: 'valueVideo',
    nombre: 'Video',
    value: 'On',
    widge: 'video',
    valor: true,
  },
  {
    id: 'valueWeather',
    nombre: 'Weather',
    value: 'On',
    widge: 'weather',
    valor: true,
  },
  {
    id: 'valueEnergy',
    nombre: 'Energy',
    value: 'On',
    widge: 'energy',
    valor: true,
  },
  {
    id: 'valuePerformanceRatio',
    nombre: 'Performance Ratio (PR)',
    value: 'On',
    widge: 'perfRatio',
    valor: true,
  },
  {
    id: 'valueRoi',
    nombre: 'disponibilidad',
    value: 'On',
    widge: 'roi',
    valor: true,
  },
  {
    id: 'valueRetorno',
    nombre: 'potencia específica',
    value: 'On',
    widge: 'retornoOper',
    valor: true,
  },
  {
    id: 'valueEnergyRvE',
    nombre: 'Energía real vs. estimada',
    value: 'On',
    widge: 'energyRvE',
    valor: true,
  },
  {
    id: 'valueRadiacion',
    nombre: 'Radiación real vs. estimada',
    value: 'On',
    widge: 'radiacion',
    valor: true,
  },
  {
    id: 'valueMercado',
    nombre: 'Precio de mercado',
    value: 'On',
    widge: 'mercado',
    valor: true,
  },
  {
    id: 'valueRentabilidad',
    nombre: 'potencia',
    value: 'On',
    widge: 'rentabilidad',
    valor: true,
  },
  {
    id: 'valueImpactoCO2',
    nombre: 'Impacto huella de CO2',
    value: 'On',
    widge: 'co2',
    valor: true,
  },
];

const withCard = 4;

export const LayoutData = width => {
  return [
    { i: '1', x: 0, y: 0, w: width, h: width / 1.5, minW: 1, minH: 1 },
    { i: '2', x: 4, y: 0, w: width, h: width / 1.5, minW: 1, minH: 1 },
    { i: '3', x: 8, y: 0, w: width, h: width / 1.5, minW: 1, minH: 1 },
    { i: '4', x: 0, y: 6, w: width, h: width / 1.5, minW: 1, minH: 1 },
    { i: '5', x: 4, y: 6, w: width, h: width / 1.5, minW: 1, minH: 1 },
    { i: '6', x: 8, y: 6, w: width, h: width / 1.5, minW: 1, minH: 1 },
    { i: '7', x: 0, y: 9, w: width, h: width / 1.5, minW: 1, minH: 1 },
    { i: '8', x: 4, y: 9, w: width, h: width / 1.5, minW: 1, minH: 1 },
    { i: '9', x: 8, y: 9, w: width, h: width / 1.5, minW: 1, minH: 1 },
  ];
};

export const LayoutLg = [
  {
    i: '1',
    x: 0,
    y: 0,
    w: withCard,
    h: withCard / 1.5,
    url: '/map',
    minW: 1,
    minH: 1,
  },
  {
    i: '2',
    x: 4,
    y: 0,
    w: withCard,
    h: withCard / 1.5,
    url: '/video',
    minW: 1,
    minH: 1,
  },
  {
    i: '3',
    x: 8,
    y: 0,
    w: withCard,
    h: withCard / 1.5,
    url: '/weather',
    minW: 4,
    minH: 4 / 1.5,
  },
  {
    i: '4',
    x: 0,
    y: 6,
    w: withCard,
    h: withCard / 1.5,
    url: '/bar',
    minW: 1,
    minH: 1,
  },
  {
    i: '5',
    x: 4,
    y: 6,
    w: withCard,
    h: withCard / 1.5,
    url: '/pie',
    minW: 1,
    minH: 1,
  },
  {
    i: '6',
    x: 8,
    y: 6,
    w: withCard,
    h: withCard / 1.5,
    url: '/line',
    minW: 1,
    minH: 1,
  },
  {
    i: '7',
    x: 0,
    y: 9,
    w: withCard,
    h: withCard / 1.5,
    url: '/area',
    minW: 1,
    minH: 1,
  },
  {
    i: '8',
    x: 4,
    y: 9,
    w: withCard,
    h: withCard / 1.5,
    url: '/bar',
    minW: 1,
    minH: 1,
  },
  {
    i: '9',
    x: 8,
    y: 9,
    w: withCard,
    h: withCard / 1.5,
    url: '/doughnut',
    minW: 1,
    minH: 1,
  },
  {
    i: '10',
    x: 0,
    y: 12,
    w: withCard,
    h: withCard / 1.5,
    url: '/line',
    minW: 1,
    minH: 1,
  },
  {
    i: '11',
    x: 4,
    y: 12,
    w: withCard,
    h: withCard / 1.5,
    url: '/line',
    minW: 1,
    minH: 1,
  },
  {
    i: '12',
    x: 8,
    y: 12,
    w: withCard,
    h: withCard / 1.5,
    url: '/line',
    minW: 1,
    minH: 1,
  },
];
export const LayoutMd = [
  {
    i: '1',
    x: 0,
    y: 0,
    w: withCard,
    h: withCard / 1.5,
    url: '/map',
    minW: 1,
    minH: 1,
  },
  {
    i: '2',
    x: 4,
    y: 0,
    w: withCard,
    h: withCard / 1.5,
    url: '/video',
    minW: 1,
    minH: 1,
  },
  {
    i: '3',
    x: 0,
    y: 6,
    w: withCard,
    h: withCard / 1.5,
    url: '/weather',
    minW: 4,
    minH: 4 / 1.5,
  },
  {
    i: '4',
    x: 4,
    y: 6,
    w: withCard,
    h: withCard / 1.5,
    url: '/bar',
    minW: 1,
    minH: 1,
  },
  {
    i: '5',
    x: 0,
    y: 9,
    w: withCard,
    h: withCard / 1.5,
    url: '/pie',
    minW: 1,
    minH: 1,
  },
  {
    i: '6',
    x: 4,
    y: 9,
    w: withCard,
    h: withCard / 1.5,
    url: '/line',
    minW: 1,
    minH: 1,
  },
  {
    i: '7',
    x: 0,
    y: 12,
    w: withCard,
    h: withCard / 1.5,
    url: '/area',
    minW: 1,
    minH: 1,
  },
  {
    i: '8',
    x: 4,
    y: 12,
    w: withCard,
    h: withCard / 1.5,
    url: '/bar',
    minW: 1,
    minH: 1,
  },
  {
    i: '9',
    x: 0,
    y: 15,
    w: withCard,
    h: withCard / 1.5,
    url: '/doughnut',
    minW: 1,
    minH: 1,
  },
  {
    i: '10',
    x: 4,
    y: 15,
    w: withCard,
    h: withCard / 1.5,
    url: '/line',
    minW: 1,
    minH: 1,
  },
  {
    i: '11',
    x: 0,
    y: 18,
    w: withCard,
    h: withCard / 1.5,
    url: '/line',
    minW: 1,
    minH: 1,
  },
  {
    i: '12',
    x: 4,
    y: 18,
    w: withCard,
    h: withCard / 1.5,
    url: '/line',
    minW: 1,
    minH: 1,
  },
];

export const LayoutSm = [
  {
    i: '1',
    x: 0,
    y: 0,
    w: withCard,
    h: withCard / 1.5,
    url: '/map',
    minW: 1,
    minH: 1,
  },
  {
    i: '2',
    x: 0,
    y: 6,
    w: withCard,
    h: withCard / 1.5,
    url: '/video',
    minW: 1,
    minH: 1,
  },
  {
    i: '3',
    x: 0,
    y: 9,
    w: withCard,
    h: withCard / 1.5,
    url: '/weather',
    minW: 4,
    minH: 4 / 1.5,
  },
  {
    i: '4',
    x: 0,
    y: 12,
    w: withCard,
    h: withCard / 1.5,
    url: '/bar',
    minW: 1,
    minH: 1,
  },
  {
    i: '5',
    x: 0,
    y: 15,
    w: withCard,
    h: withCard / 1.5,
    url: '/pie',
    minW: 1,
    minH: 1,
  },
  {
    i: '6',
    x: 0,
    y: 18,
    w: withCard,
    h: withCard / 1.5,
    url: '/line',
    minW: 1,
    minH: 1,
  },
  {
    i: '7',
    x: 0,
    y: 21,
    w: withCard,
    h: withCard / 1.5,
    url: '/area',
    minW: 1,
    minH: 1,
  },
  {
    i: '8',
    x: 0,
    y: 24,
    w: withCard,
    h: withCard / 1.5,
    url: '/bar',
    minW: 1,
    minH: 1,
  },
  {
    i: '9',
    x: 0,
    y: 27,
    w: withCard,
    h: withCard / 1.5,
    url: '/doughnut',
    minW: 1,
    minH: 1,
  },
  {
    i: '10',
    x: 0,
    y: 30,
    w: withCard,
    h: withCard / 1.5,
    url: '/line',
    minW: 1,
    minH: 1,
  },
  {
    i: '11',
    x: 0,
    y: 33,
    w: withCard,
    h: withCard / 1.5,
    url: '/line',
    minW: 1,
    minH: 1,
  },
  {
    i: '12',
    x: 0,
    y: 36,
    w: withCard,
    h: withCard / 1.5,
    url: '/line',
    minW: 1,
    minH: 1,
  },
];

export const users = [
  { name: 'Usuario1', role: 'admin', alta: true, plantas: [0, 1] },
  { name: 'Usuario2', role: 'admin', alta: true, plantas: [1, 2] },
  { name: 'Usuario3', role: 'admin', alta: true, plantas: [0, 2] },
  { name: 'Usuario4', role: 'user', alta: false, plantas: [2] },
  { name: 'Usuario5', role: 'user', alta: true, plantas: [0, 1, 2] },
  { name: 'Usuario5', role: 'user', alta: true, plantas: [0, 1, 2] },
  { name: 'Usuario5', role: 'user', alta: true, plantas: [0, 1, 2] },
  { name: 'Usuario5', role: 'user', alta: true, plantas: [0, 1, 2] },
  { name: 'Usuario5', role: 'user', alta: true, plantas: [0, 1, 2] },
  { name: 'Usuario5', role: 'user', alta: true, plantas: [0, 1, 2] },
  { name: 'Usuario6', role: 'user', alta: true, plantas: [0, 2] },
];
export const plantas = [
  { name: 'Planta 0', value: true, code: 'Planta 0' },
  { name: 'Planta 1', value: true, code: 'Planta 1' },
  { name: 'Planta 2', value: true, code: 'Planta 2' },
  { name: 'Planta 3', value: true, code: 'Planta 3' },
  { name: 'Planta 4', value: true, code: 'Planta 4' },
  { name: 'Planta 5', value: true, code: 'Planta 5' },
  { name: 'Planta 6', value: true, code: 'Planta 6' },
];

export const markers = {
  markers: [
    {
      position: [42.7723478, -1.6272936],
      latitud: 42.7723478,
      longitud: -1.6272936,
      title: 'Marcador 1',
      text: 'Geoactio lacation',
      planta: 'planta0',
      pico: '115',
      pais: 'España',
      probjetivo: '11',
      tipo: 'asd',
    },
    {
      position: [42.7723478, -1.617292],
      latitud: 42.7723478,
      longitud: -1.617292,
      title: 'Marcador 2',
      text: 'Geoactio2 lacation',
      planta: 'planta1',
      pico: '90',
      pais: 'España',
      probjetivo: '11',
      tipo: 'asd',
    },
    {
      position: [42.7623478, -1.617292],
      latitud: 42.7623478,
      longitud: -1.617292,
      title: 'Marcador 3',
      text: 'Geoactio3 lacation',
      planta: 'planta2',
      pico: '70',
      pais: 'España',
      probjetivo: '11',
      tipo: 'asd',
    },
    {
      position: [42.7523478, -1.647292],
      latitud: 42.7523478,
      longitud: -1.647292,
      title: 'Marcador 4',
      text: 'Geoactio4 lacation',
      planta: 'planta3',
      pico: '80',
      pais: 'España',
      probjetivo: '11',
      tipo: 'asd',
    },
    {
      position: [42.79234, -1.647202],
      latitud: 42.79234,
      longitud: -1.647202,
      title: 'Marcador 5',
      text: 'Geoactio5 lacation',
      planta: 'planta4',
      pico: '190',
      pais: 'España',
      probjetivo: '11',
      tipo: 'asd',
    },
    {
      position: [41.547852, -0.890558],
      latitud: 41.547852,
      longitud: -0.890558,
      title: 'OMES30 Mi Ranchito',
      text: 'OMES30 Mi Ranchito',
      planta: 'planta6',
      pico: '95.5',
      pais: 'México',
      probjetivo: '87',
      tipo: 'asd',
    },
  ],
};
